module.exports = __webpack_public_path__ + "static/img/facebook.c0ccf4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = 1072
// module chunks = 38